module.exports = __webpack_public_path__ + "static/6-989fe532b6f0a3276e972eabfe2974c5.jpg";